import { ALL_DIGIT } from "presentation/validation/constants"

const neighborhoodFormatter = (value: string) => {
    if (!ALL_DIGIT.test(value)) return value
    return value.replace(/\d{3}(?=.)/g, "$&/")
}

export default neighborhoodFormatter